import client from './client';
import { WaitlistResult, WaitlistSignup, WaitlistSummary } from '../types/waitlist';

export interface WaitlistParams {
  search?: string;
  page?: number;
  limit?: number;
  consentOnly?: boolean;
  unconvertedOnly?: boolean;
}

const EMPTY_SUMMARY: WaitlistSummary = {
  total_signups: 0,
  consented: 0,
  converted: 0,
  not_converted: 0,
};

export async function getWaitlist(params: WaitlistParams = {}): Promise<WaitlistResult> {
  const limit = params.limit ?? 20;
  const query: Record<string, string | number> = { page: params.page ?? 1, limit };
  if (params.search) query.search = params.search;
  if (params.consentOnly) query.consent_only = 'true';
  // "Show unconverted only" maps to the API's converted=false filter.
  if (params.unconvertedOnly) query.converted = 'false';

  const res = await client.get('/api/admin/waitlist', { params: query });
  const data = res.data ?? {};
  const signups: WaitlistSignup[] = Array.isArray(data.signups) ? data.signups : [];
  const pagination = data.pagination ?? {};

  return {
    signups: signups.map((s) => ({ ...s, whatsapp_consent: Boolean(s.whatsapp_consent) })),
    total: pagination.total ?? signups.length,
    totalPages: pagination.pages ?? Math.max(1, Math.ceil((pagination.total ?? signups.length) / limit)),
    summary: data.summary ?? EMPTY_SUMMARY,
  };
}
